import { useEffect } from "react";
import { Box } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { RootState } from "../../../../app/rootReducer";
import { fetchFinanceIrelandEstimate } from "../../../../store/QuoteSlice";
import { MAX_FINAL_COST, MIN_FINAL_COST } from "../../quoteDetail.constants";
import { quoteVat, solarGrantAmountAvailable } from "../../../../app/utils";
import { EQuotePurchaserType, EQuoteType } from "../../../../api/Types";
import { PriceFormat } from "../../../../components/typography/PriceFormat";

export const QuoteTotal = ({ fullPrice, price }: { fullPrice: number; price: number }) => {
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  const { quote, solarReport, financeIrelandEstimate } = useSelector((state: RootState) => state.quote);
  const dispatch = useDispatch();

  const grantAmountAvailable = solarGrantAmountAvailable(quote, solarReport);

  var priceExcludingGrant = price - Number(grantAmountAvailable || 0);

  useEffect(() => {
    if (quote?.type === EQuoteType.Solar) {
      dispatch(fetchFinanceIrelandEstimate(priceExcludingGrant));
    }
  }, [dispatch, quote, priceExcludingGrant]);

  return (
    <Box
      mt={isMoreThanSm ? "23px" : "30px"}
      pr={isMoreThanMd ? 0 : isMoreThanSm ? "72px" : "0"}
      pl={isMoreThanMd ? 0 : isMoreThanSm ? "72px" : "0"}
      maxWidth={isMoreThanSm ? "100%" : "272px"}
      mx={isMoreThanSm ? 0 : "auto"}
    >
      <Box
        fontWeight={500}
        fontSize={isMoreThanSm ? "14px" : "12px"}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        color={"#4b5462"}
      >
        <Box>Total payable to Swyft Energy {quote?.purchaserType !== EQuotePurchaserType.Home && <>(incl. VAT)</>}</Box>
        <PriceFormat value={price} decimalScale={quote?.purchaserType === EQuotePurchaserType.Home ? 2 : 0} />
      </Box>
      {solarReport && grantAmountAvailable ? (
        <Box
          fontWeight={500}
          fontSize={isMoreThanSm ? "14px" : "12px"}
          display={"flex"}
          mt={isMoreThanSm ? "10px" : "8px"}
          alignItems={"center"}
          justifyContent={"space-between"}
          color={"#f7815c"}
        >
          <Box color={"#4b5462"}>Total grants available</Box>
          <PriceFormat value={grantAmountAvailable} prefix={"-€"} />
        </Box>
      ) : null}
      <Box
        fontWeight={500}
        fontSize={isMoreThanSm ? "14px" : "12px"}
        display={"flex"}
        mt={isMoreThanSm ? "25px" : "18px"}
        alignItems={"start"}
        justifyContent={"space-between"}
        color={"#160037"}
      >
        <Box>Final cost to you {quote?.purchaserType !== EQuotePurchaserType.Home && <>(excl. VAT)</>}</Box>
        <Box display={"flex"} flexDirection={"column"} alignItems={"end"}>
          <Box fontSize={isMoreThanSm ? "22px" : "18px"}>
            <span style={{ borderBottom: "2px solid #160037" }}>
              <PriceFormat
                value={priceExcludingGrant - (quote?.purchaserType === EQuotePurchaserType.Home ? 0 : quoteVat(quote))}
                decimalScale={quote?.purchaserType === EQuotePurchaserType.Home ? 2 : 0}
              />
            </span>
          </Box>
          {priceExcludingGrant < MAX_FINAL_COST &&
          priceExcludingGrant > MIN_FINAL_COST &&
          financeIrelandEstimate?.monthlyPayment ? (
            <>
              <Box
                fontSize={isMoreThanSm ? "11px" : "9px"}
                fontWeight={500}
                mt={isMoreThanSm ? "10px" : "5px"}
                color="#84868c"
              >
                OR{" "}
                <span style={{ fontSize: isMoreThanSm ? "15px" : "13px" }}>
                  <PriceFormat value={financeIrelandEstimate?.monthlyPayment || 0} />
                </span>{" "}
                pm
              </Box>
              <img src="images/financeIreland.png" alt="financeIreland" height={isMoreThanSm ? "11px" : "9px"} />
            </>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};
